import React, { useContext } from 'react';
import { Text, View } from 'react-native';
import styled from 'styled-components/native'
import { ThemeProvider, ThemeContext } from 'styled-components/native';
import { PageBlock, BasicText, Paragraph, Heading, Button } from './index';

export default function JunkSummary({portalData}){
	/** if (portalData.materials == null){
		return <Loading/>
	};
    **/

    return <View>
            <View style={{backgroundColor: 'pink', padding: 20}}><Text style={{backgroundColor: 'red'}}>Test</Text></View>
            <WasteApp>
                <Paragraph warning={1}>Hey There!</Paragraph>
                <Thing/>
                <Button>Test Button</Button>
                <BasicText>Test</BasicText>
                <PageBlock>
                    <Heading>Title Here Title Here Title Here Title Here </Heading>
                    <Paragraph>Hey There!</Paragraph>
                </PageBlock>

                <View style={{flexDirection:'row', flexGrow: 20}}>
                    <PageBlock height="350px">
                        <Heading>Title Here</Heading>
                        <Paragraph>Hey There!</Paragraph>
                    </PageBlock>
                    <PageBlock>
                        <Heading>Title Here</Heading>
                        <Paragraph>Hey There!</Paragraph>
                    </PageBlock>
                </View>

                <PageBlock>
                    <Heading>Title Here</Heading>
                    <Paragraph>Hey There!</Paragraph>
                </PageBlock>
            </WasteApp>
        </View>
}

const WasteApp = (props)=>{
    const myBrand = {brandColor: "orange", sm: "14px", med: "22px", lg: "36px", rounded: 0 };

    return <ThemeProvider theme={myBrand}>
        <BasicText>Hey</BasicText>
        {props.children}
    </ThemeProvider>
}

const Thing = ()=>{
    const theme = useContext(ThemeContext);
    
    return <Text>Hey theme</Text>;
}